export const addiIcon = 'https://statics.addi.com/widget/logo.png';
export const addiLogo = 'https://statics.addi.com/widget/addi-logo.svg';
export const addiLogoWhite =
  'https://statics.addi.com/widget/addi-logo-blanco.png';
export const closeBtnImg = 'https://statics.addi.com/widget/close_big.png';
